import { useApiClient } from "./useApiClient";
import { useResource, type ResourceState } from "./useResource";
import { FeaturesApi, type FeatureGatesResponse } from "../api/features";

/** Fetch the platform feature-gate registry with current values. */
export function useFeatureGates(): ResourceState<FeatureGatesResponse> {
  const client = useApiClient();
  return useResource<FeatureGatesResponse>(
    async () => {
      if (!client) return null;
      const res = await new FeaturesApi(client).getFeatureGates();
      return res.data ?? null;
    },
    [client],
  );
}
